import { render, staticRenderFns } from "./resetTradeDc.vue?vue&type=template&id=e02f94f4&scoped=true"
import script from "./resetTradeDc.vue?vue&type=script&lang=js"
export * from "./resetTradeDc.vue?vue&type=script&lang=js"
import style0 from "./resetTradeDc.vue?vue&type=style&index=0&id=e02f94f4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e02f94f4",
  null
  
)

export default component.exports